import { FieldError } from "./field-error";

export class StepWarning {
    public warnings: FieldError[];
    public isCheckValid: boolean;

}
